/*
 * UI data
 */

const UI = ( Vue ) => {

	const UI = new Vue({
		data: {
			device: null,
			height: null,
			width: null,
			isMobile: null,
			isTablet: null,
			isDesktop: null,
			scroll: null,
			direction: null,
		},
	})

	const style = window.getComputedStyle(window.document.body)

	const breakpoints = {
		mobile: parseInt(style.getPropertyValue('--breakpoint-mobile')) || 841,
		tablet: parseInt(style.getPropertyValue('--breakpoint-tablet')) || 1081,
		desktop: parseInt(style.getPropertyValue('--breakpoint-desktop')) || 1441,
	}

	function onResize() {
		UI.height = window.innerHeight
		UI.width = window.innerWidth
		if (breakpoints.mobile > UI.width && 'mobile' !== UI.device) {
			UI.device = 'mobile'
			UI.isMobile = true
			UI.isTablet = false
			UI.isDesktop = false
		} else if (breakpoints.mobile <= UI.width && breakpoints.tablet > UI.width && 'desktop' !== UI.device) {
			UI.device = 'tablet'
			UI.isMobile = false
			UI.isTablet = true
			UI.isDesktop = false
		} else if (breakpoints.tablet <= UI.width && 'desktop' !== UI.device) {
			UI.device = 'desktop'
			UI.isMobile = false
			UI.isTablet = false
			UI.isDesktop = true
		}
	}

	function onScroll() {
		const { scrollTop } = document.documentElement
		if (0 === scrollTop) {
			UI.direction = null
		} else if (scrollTop > UI.scroll && 'down' !== UI.direction) {
			UI.direction = 'down'
		} else if (scrollTop < UI.scroll && 'up' !== UI.direction) {
			UI.direction = 'up'
		}
		UI.scroll = scrollTop
	}

	window.addEventListener('orientationchange', onResize)
	window.addEventListener('resize', onResize)
	window.addEventListener('orientationchange', onScroll)
	window.addEventListener('resize', onScroll)
	window.addEventListener('scroll', onScroll)

	onResize()
	onScroll()

	return UI

}

/*
 * Export default
 */

export default UI
